// extracted by mini-css-extract-plugin
export default {"SearchFieldIcon":"_SearchFieldIcon--ck62f"};